<template>
    <div>
        <base-dropdown :position="'right'" v-if="allow_read_wallet_info">
            <template slot="title">
                <div class="media align-items-center custom-media-nav-size" slot="title">
                    <i class="fas fa-copyright text-color-wallet"></i>
                    <div :class="['media-body ml-2 d-none d-md-block d-lg-block pr-1', { 'text-color-wallet': !load_wallet_balances }]">
                        <span v-bind:style="{color: this.$THEME.primaryColor}" :class="(this.$THEME.primaryColor?'':'text-blue')" v-if="load_wallet_balances">
                            <i class="fas fa-circle-notch fa-spin"></i>
                        </span>
                        <span class="mb-0 text-sm font-weight-bold color-text-li" v-else>
                            {{$WALLET.available_balance | numFormat('0,0.00')}}
                            <p class="mb-0 small text-right">เครดิต</p>
                        </span>
                    </div>
                </div>
            </template>
            <template v-if="allow_view_wallet_dropdown">
                <router-link to="/topupcredit" class="dropdown-item" v-if="this.$USER_LOGIN.get().details.payment_type == 'PREPAID'">
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิต</span>
                </router-link>
                <router-link to="/history/topupwallet" class="dropdown-item">
                    <i class="fas fa-file-alt" v-bind:style="{color: this.$THEME.primaryColor}"></i>
                    <span>ประวัติเติมเครดิต</span>
                </router-link>
                <router-link to="/history/usagewallet" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งาน</span>
                </router-link>
            </template>
            <template v-if="this.$USER_LOGIN.get().isSuperadmin && this.$THEME.name !== 'shippop'">
                <router-link to="/topupcredit/shop" class="dropdown-item" v-if="this.$THEME.manageVision.menuTopUpCreditSA">
                    <Icon icon="mdi-wallet-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>เติมเครดิตให้สาขา</span>
                </router-link>
                <router-link to="/history/topupcredit/superadmin" class="dropdown-item">
                    <Icon icon="mdi-file-document" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติเติมเครดิตของสาขา</span>
                </router-link>
                <router-link to="/history/usagewallet/superadmin" class="dropdown-item">
                    <Icon icon="mdi-text-box-search" v-bind:style="{color: this.$THEME.primaryColor}" />
                    <span>ประวัติการใช้งานเครดิต</span>
                </router-link>
                <a
                    class="dropdown-item"
                    @click="withdraw_credit.show = true" >
                    <Icon icon="mdi-notebook-plus" v-bind:style="{color: this.$THEME.primaryColor}" />
                    ถอนเครดิต
                </a>
            </template>
        </base-dropdown>
        <ModalWithDrawCredit :withdraw_credit="withdraw_credit" />
    </div>
  </template>

  <script>
  import ModalWithDrawCredit from '@/components/Modals/ModalWithDrawCredit'
  import {
    fetchWalletBanlancesToLocalStorage,
    fetchWalletMetadataToLocalStorage,
    fetchShopMetadataToLocalStorage
  } from "@/axios/walletPayment.js"

  export default {
    name:"DropDownWallet",
    components:{
        ModalWithDrawCredit
    },

    data() {
        return {
            withdraw_credit:{
                show: false
            },
            load_wallet_balances: true,

            allow_view_wallet_dropdown: false,
            allow_read_wallet_info    : false,
        }
    },

    created() {
        if ([
            this.$USER_LOGIN.get().isAdmin,
            this.$USER_LOGIN.get().isMember
        ].includes(true) && this.$USER_LOGIN.get().isPaymentTypePrepaid) {
            this.allow_read_wallet_info = true
        }

        if (
            this.$USER_LOGIN.get().isAdmin
            && this.$USER_LOGIN.get().isPaymentTypePrepaid
        ) {
            this.allow_view_wallet_dropdown = true
        }
    },

    mounted() {
        if (this.allow_read_wallet_info) {
            fetchWalletBanlancesToLocalStorage(this.main_use_walletV2).then(res => {
                this.$WALLET.balance           = res.balance
                this.$WALLET.peg_balance       = res.peg_balance
                this.$WALLET.available_balance = res.available_balance
            })
            .catch()
            .finally(() => {
                this.load_wallet_balances = false
            });

            fetchWalletMetadataToLocalStorage(this.main_use_walletV2)
                .catch();
        }

        fetchShopMetadataToLocalStorage()
            .catch();
    },
  }
  </script>
